import { EditCompanyPanelGzDataProvider } from '../dataProvider/EditCompanyPanelGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';

export class EditCompanyPanelDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, EditCompanyPanelGzDataProvider);
  }
}
